import {
  Blueprint as BlueprintIcon,
  CalendarCheck,
  Cube,
  Package,
  Truck,
  HardHat,
  Broadcast,
} from "@phosphor-icons/react";
import { subdomainImage } from "./utils";

const slug = "precast";

/** Precast — precast.bizlem.com */
const precastConfig = {
  slug,
  name: "Precast",
  shortName: "Precast",
  host: "precast.bizlem.com",
  icon: BlueprintIcon,
  theme: {
    primary: "bg-orange-500",
    primaryHover: "hover:bg-orange-600",
    primaryText: "text-orange-600",
    primaryBorder: "border-orange-500",
    tint: "bg-orange-50",
    heroGradient: "from-orange-700 via-orange-500 to-orange-400",
    cream: "bg-orange-50/40",
    badge: "bg-orange-50 border-orange-200 text-orange-700",
    ring: "ring-orange-100",
  },
  hero: {
    badge: "AI-Powered Precast Intelligence",
    headline: ["Faster Cycles.", "Higher Quality.", "On-Time Delivery."],
    highlightLine: 1,
    description:
      "End-to-end precast production intelligence — from mold scheduling and quality control to logistics and site delivery tracking.",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    ctaPrimary: "Request Demo",
    ctaSecondary: "Explore Solutions",
  },
  about: {
    label: "WHAT WE DO",
    heading: "Enabling precast producers with smart, connected operations",
    body: "From batch plants to casting beds and site erection, our platform connects production scheduling, quality assurance, inventory, and logistics into one intelligent precast system.",
  },
  modules: {
    label: "MODULES",
    heading: "Integrated Modules. One Intelligent Precast Plant.",
    body: "Purpose-built modules for precast operations that work together — so production, quality, inventory, and delivery run on a single connected platform.",
    items: [
      { icon: CalendarCheck, title: "Production Scheduling", body: "AI-optimized mold scheduling, bed allocation, and cycle time management across product lines.", iconBg: "bg-orange-100 text-orange-700" },
      { icon: Cube, title: "Quality Control", body: "Automated quality checks, curing monitoring, and non-conformance tracking with vision analytics.", iconBg: "bg-blue-100 text-blue-700" },
      { icon: Package, title: "Inventory & Yard Management", body: "Real-time yard inventory, stacking optimization, and dispatch readiness tracking.", iconBg: "bg-emerald-100 text-emerald-700" },
      { icon: Truck, title: "Logistics & Delivery", body: "Route optimization, crane scheduling, and site delivery coordination with live tracking.", iconBg: "bg-amber-100 text-amber-700" },
      { icon: HardHat, title: "Site Erection Intelligence", body: "Erection sequence planning, progress tracking, and safety compliance for on-site assembly.", iconBg: "bg-rose-100 text-rose-700" },
      { icon: Broadcast, title: "Plant Command Center", body: "Unified operations dashboard for plant managers with real-time KPIs and alerts.", iconBg: "bg-violet-100 text-violet-700" },
    ],
  },
  solutions: {
    label: "SOLUTIONS",
    heading: "Built for every precast operation",
    items: [
      {
        title: "Structural Precast",
        points: ["Beam & column scheduling", "Prestress monitoring", "Structural QA automation", "Erection sequencing"],
        image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      },
      {
        title: "Architectural Precast",
        points: ["Finish quality control", "Color & texture matching", "Custom mold tracking", "Aesthetic QA workflows"],
        image: subdomainImage(slug, "architectural-precast.png"),
      },
      {
        title: "Precast Plants",
        points: ["Multi-bed optimization", "Batch plant integration", "Energy & resource tracking", "OEE analytics"],
        image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      },
      {
        title: "EPC & Project Delivery",
        points: ["Project milestone tracking", "Contractor coordination", "Cost & schedule intelligence", "BIM integration"],
        image: subdomainImage(slug, "epc-project-delivery.png"),
      },
    ],
  },
  whyChoose: {
    label: "WHY CHOOSE US",
    heading: "Built for Scale. Designed for Simplicity.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    items: [
      "One unified platform for all precast operations",
      "Scalable from single plants to multi-facility networks",
      "Proven cycle time and quality improvements",
      "Seamless integration with ERP and BIM systems",
    ],
  },
  footerTagline:
    "AI-Powered Precast Intelligence — connecting production, quality, and delivery into measurable project outcomes.",
  contactIndustry: "Construction & Precast",
};

export default precastConfig;
